import { getTextColor as r, getBorderColor as a } from "./get-text-color-contrast.mjs";
const i = (l) => {
  const { primaryColor: t, secondaryColor: e, tertiaryColor: o } = l, C = r(t), n = r(e), c = r(o), s = a(o);
  return {
    primaryColor: t,
    secondaryColor: e,
    tertiaryColor: o,
    textColorPrimary: C,
    textColorSecondary: n,
    textColorTertiary: c,
    borderColorTertiary: s
  };
};
export {
  i as getColors
};
